// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3tuhE","productName":"Table_productName__1OCZA"};